import React, { useEffect, useState } from 'react';
import { Modal, Table, Button, Select, Space, Typography, message } from 'antd';
import apiClient from '../../../shared/services/apiClient';

const { Text } = Typography;

// 按访问日志找「这个节点对某地区浏览器访问很多、HTTP/3 一条没有,而同地区访问其它节点有」→ 建议加进不提供 HTTP/3
const H3Suggestions = ({ open, onClose, onApplied }) => {
    const [hours, setHours] = useState(24);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [applying, setApplying] = useState(null);

    const load = async () => {
        setLoading(true);
        try {
            const r = await apiClient.get('/api/admin/nodes/h3-suggestions', { params: { hours } });
            setRows(r.data?.data?.suggestions || []);
        } catch (e) {
            message.error(e.response?.data?.error || e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) load();
    }, [open, hours]); // eslint-disable-line react-hooks/exhaustive-deps

    const apply = async (row) => {
        const key = `${row.node_id}|${row.token}`;
        setApplying(key);
        try {
            await apiClient.post('/api/admin/nodes/h3-apply', { node_id: row.node_id, token: row.token });
            message.success(`${row.node}: 已不对 ${row.token} 提供 HTTP/3`);
            setRows((rs) => rs.filter((r) => `${r.node_id}|${r.token}` !== key));
            onApplied?.();
        } catch (e) {
            message.error(e.response?.data?.error || e.message);
        } finally {
            setApplying(null);
        }
    };

    return (
        <Modal title="HTTP/3 排除建议" open={open} onCancel={onClose} footer={null} width={720}>
            <Space style={{ marginBottom: 12 }}>
                <Select value={hours} onChange={setHours} style={{ width: 120 }}
                    options={[24, 48, 72, 168].map((h) => ({ value: h, label: `最近 ${h} 小时` }))} />
                <Text type="secondary">只统计开启 HTTP/3 的域名的浏览器访问</Text>
            </Space>
            <Table
                size="small"
                loading={loading}
                rowKey={(r) => `${r.node_id}|${r.token}`}
                dataSource={rows}
                pagination={false}
                locale={{ emptyText: '没有异常' }}
                columns={[
                    { title: '节点', dataIndex: 'node' },
                    { title: '访客', dataIndex: 'token' },
                    { title: '请求数(H3=0)', dataIndex: 'requests' },
                    { title: '其它节点 H3 比例', dataIndex: 'baseline', render: (v) => `${(v * 100).toFixed(1)}%` },
                    {
                        title: '', key: 'op', render: (_, r) => (
                            <Button size="small" loading={applying === `${r.node_id}|${r.token}`} onClick={() => apply(r)}>不提供 H3</Button>
                        ),
                    },
                ]}
            />
        </Modal>
    );
};

export default H3Suggestions;
